export default 'bonus-material'
